import React from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

import { usdcToUsd } from "@/helpers";
import { RootState } from "@/store";

export const useTicketBalance = () => {
  const { data: profileData } = useSelector(
    (state: RootState) => state.profile
  );
  const ticketsTotalAmount = React.useMemo(
    () =>
      profileData?.tickets?.reduce((total, ticket) => {
        if (
          !ticket.used &&
          dayjs().isBefore(dayjs((ticket.expiration_date ?? 0) * 1000))
        ) {
          return total + usdcToUsd(Number(ticket?.amount ?? 0));
        }
        return total;
      }, 0) ?? 0,
    [profileData?.tickets]
  );

  return ticketsTotalAmount;
};
